import {EyeIcon} from "../../../assets/icons";
import useSlideOver from "../../SlideOver/useSlideOver";
import UseContext from "../../../hooks/useContext";
import {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import TableCell from "./TableCell";
import TableRow from "./TableRow";

const Tbodycompany = ({champsBody}) => {
    const {objID, setObjID}=UseContext()
    const {toggleSlideOver} = useSlideOver();
    const navigate = useNavigate();
    const location = useLocation();
    const urlParams = new URLSearchParams(window.location.search);
    const idCompany = urlParams.get('idCompany');
    const [selectedId, setSelectedId] = useState(null);

    const openCompanyInfo = (id) => {
        setObjID(id)
        toggleSlideOver('get_company')
        navigate('/company?idCompany=' + id);
    }

    useEffect(() => {
        if(idCompany) {
            if(!objID){
                openCompanyInfo(idCompany)
            } else {
                if(idCompany !== objID) {
                    openCompanyInfo(idCompany)
                }
            }
        }
    }, [idCompany])

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const id = params.get('idCompany');
        if (id) {
            setSelectedId(id);
        }
    }, [location]);

    return (
        <>
            {champsBody?.map((company, key) => {
                return (
                    <TableRow
                        key={key}
                        itemId={company._id}
                        selectedId={selectedId}
                        onClick={openCompanyInfo}
                    >
                        <TableCell position="first" columnIndex={0}>
                            {company.name_commercial}
                        </TableCell>
                        <TableCell columnIndex={1}>
                            {company.bigAccounts?.join(', ')}
                        </TableCell>
                        <TableCell columnIndex={2}>
                            {('0' + new Date(company.createdAt).getDate()).toString().slice(-2) + '/' + ('0' + (new Date(company.createdAt).getMonth() + 1)).toString().slice(-2) + '/' + new Date(company.createdAt).getFullYear()}
                        </TableCell>
                        <TableCell 
                            position="last"
                            hasButton
                            buttonOnClick={(e) => {
                                e.stopPropagation();
                                openCompanyInfo(company._id);
                            }}
                            buttonContent={<EyeIcon wh={20} color={'#374151'}/>}
                        />
                    </TableRow>
                );
            })}
        </>
    )
}

export default Tbodycompany;